import { render, staticRenderFns } from "./DeleteRecord.vue?vue&type=template&id=718b64f9&scoped=true&"
import script from "./DeleteRecord.vue?vue&type=script&lang=js&"
export * from "./DeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b64f9",
  null
  
)

export default component.exports